import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { BillingDetails } from "@/models/billing/BillingDetails";
import { AppService } from "@services/app.service";
import * as CryptoJS from 'crypto-js';
import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from "ngx-toastr";

@Component({
  selector: 'app-bill',
  templateUrl: './bill.component.html',
  styleUrl: './bill.component.scss'
})
export class BillComponent implements OnInit {
  billDetails: any;
  private secretKey = "#EVOL-&$%$DF%SION*^%#^*F&%^DFSEYUJ";
  billId: number = 0;
  buyerType: string = "";
  screenName: string = "";

  constructor(private route: ActivatedRoute, private appService: AppService, private router: Router,
    private spinner: NgxSpinnerService, private toastr: ToastrService) {
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      if (params['billId'], params['buyerType']) {
        const decryptedBillId = CryptoJS.AES.decrypt(params['billId'], this.secretKey).toString(CryptoJS.enc.Utf8);
        const decryptedBuyerType = CryptoJS.AES.decrypt(params['buyerType'], this.secretKey).toString(CryptoJS.enc.Utf8);
        const decryptedScreenName = CryptoJS.AES.decrypt(params['screenName'], this.secretKey).toString(CryptoJS.enc.Utf8);
        this.buyerType = decryptedBuyerType
        this.billId = Number(decryptedBillId);
        this.screenName = decryptedScreenName
      }
    });
    this.fetchBillDetails(this.billId);
  }
  

  fetchBillDetails(billId: number): void {
    this.spinner.show();
    this.appService.getBillDetailById(billId)
      .subscribe(
        (response: BillingDetails) => {
          this.spinner.hide();
          this.billDetails = response;
          setTimeout(() => {
            this.printBill();
          }, 1000);
        }, (error: any) => {
          this.spinner.hide();
          console.error('save invoice details:', error);
          this.toastr.error(error.error.message);
        },);
  }

  printBill(): void {
    window.print();
    setTimeout(() => {
      if(this.screenName == 'order-processing'){
        this.router.navigate(['/main/order-processing']);
      } else if(this.screenName == 'dispatch-management'){
        this.router.navigate(['/main/dispatch-management']);
      } else if(this.screenName == 'invoice'){
        this.router.navigate(['/main/invoice']);
      }else{
      this.router.navigate(['/main/shop-bill-list']);
      }
    }, 1000);
  }

  // For amount letter format
  numberToWords(amount: number): string {
  if (amount === null || amount === undefined || isNaN(amount)) {
    return '';
  }

  // Handle decimal values by rounding to 2 decimal places
  const number = Math.round(amount * 100) / 100;

  const units: string[] = [
    '', 'One', 'Two', 'Three', 'Four',
    'Five', 'Six', 'Seven', 'Eight', 'Nine'
  ];

  const teens: string[] = [
    'Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen',
    'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'
  ];

  const tens: string[] = [
    '', '', 'Twenty', 'Thirty', 'Forty',
    'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'
  ];

  function convertBelowHundred(num: number): string {
    if (num < 10) {
      return units[num];
    }

    if (num < 20) {
      return teens[num - 10];
    }

    const ten = Math.floor(num / 10);
    const unit = num % 10;

    return tens[ten] + (unit > 0 ? ' ' + units[unit] : '');
  }

  function convertBelowThousand(num: number): string {
    if (num < 100) {
      return convertBelowHundred(num);
    }

    const hundred = Math.floor(num / 100);
    const remainder = num % 100;

    let result = units[hundred] + ' Hundred';

    if (remainder > 0) {
      result += ' ' + convertBelowHundred(remainder);
    }

    return result;
  }

  let result = '';

  // Crore
  if (number >= 10000000) {
    const crore = Math.floor(number / 10000000);
    result += convertBelowThousand(crore) + ' Crore ';
    amount = number % 10000000;
  } else {
    amount = number;
  }

  // Lakh
  if (amount >= 100000) {
    const lakh = Math.floor(amount / 100000);
    result += convertBelowHundred(lakh) + ' Lakh ';
    amount = amount % 100000;
  }

  // Thousand
  if (amount >= 1000) {
    const thousand = Math.floor(amount / 1000);
    result += convertBelowHundred(thousand) + ' Thousand ';
    amount = amount % 1000;
  }

  // Hundred + remaining tens/units
  if (amount > 0) {
    result += convertBelowThousand(Math.floor(amount));
  }

  return result.trim() + ' Only';
}


getGrandTotal(bill: any): number {
  const withGst = Number(bill?.withGst) || 0;
  const manualDiscount = Number(bill?.manualDiscountAmount) || 0;
  const discount = Number(bill?.discount) || 0;

  return withGst - (manualDiscount + discount);
}
  getCurrentDate(): string {
    return new Date().toLocaleDateString('en-GB'); // dd/mm/yyyy format
  }

  getCurrentTime(): string {
    return new Date().toLocaleTimeString('en-US', { hour12: true }).replace(/:/g, ':'); // hh-mm-ss AM/PM
  }

}
